import React, { useState, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { cardCarouselBtnleft, cardCarouselBtnRight} from '../utils'
import 'swiper/css';
import 'swiper/css/navigation';

const cards = [
  { image: "/assets/images/algorithm/goggles.png", title: "护目镜识别算法" },
  { image: "/assets/images/algorithm/workwear-1.png", title: "工作服识别算法" },
  { image: "/assets/images/algorithm/workwear.png", title: "安全帽识别算法" },
  { image: "/assets/images/algorithm/shoe.png", title: "工鞋识别算法" },
  { image: "/assets/images/algorithm/reflective vest.png", title: "反光背心识别算法" },
  { image: "/assets/images/algorithm/face.png", title: "人脸识别算法" },
  { image: "/assets/images/algorithm/smoking.png", title: "吸烟识别算法" },
  { image: "/assets/images/algorithm/goggles.png", title: "护目镜识别算法" },
  { image: "/assets/images/algorithm/workwear-1.png", title: "工作服识别算法" },
  { image: "/assets/images/algorithm/workwear.png", title: "安全帽识别算法" },
  { image: "/assets/images/algorithm/reflective vest.png", title: "反光背心识别算法" },
  { image: "/assets/images/algorithm/shoe.png", title: "工鞋识别算法" },
  { image: "/assets/images/algorithm/face.png", title: "人脸识别算法" },
  { image: "/assets/images/algorithm/smoking.png", title: "吸烟识别算法" },
];

const CardCarousel = ({ isMobile }) => {
  const [direction, setDirection] = useState('next');
  const swiperRef = useRef(null);
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);

  const handleSlideChange = (swiper) => {
    setActiveSlideIndex(swiper.realIndex);
  };

  const handlePrev = () => {
    if (swiperRef.current) {
      setDirection('prev');
      swiperRef.current.swiper.slidePrev();
    }
  };

  const handleNext = () => {
    if (swiperRef.current) {
      setDirection('next');
      swiperRef.current.swiper.slideNext();
    }
  };

  const getCardStyle = (index) => {
    let position;
    const cardCount = cards.length;
    
    if (direction === 'next') {
      position = (index - activeSlideIndex + cardCount) % cardCount;
    } else {
      position = (activeSlideIndex - index + cardCount) % cardCount;
    }
    
    const isFullSize = position % 2 === 0;
    
    return isMobile? {
      width: 'auto',
      height: '240px',
      borderRadius: '5px',
      overflow: 'hidden',
      boxShadow: '2px 2px 12px rgba(0,0,0,0.4)',
      transition: 'transform 0.3s ease, z-index 0.3s ease, box-shadow 0.3s ease',
      transform: isFullSize ? 'scale(0.9)' : 'scale(0.7)',
      zIndex: isFullSize ? 10 : 5,
      margin: '0 auto',
      position: 'relative',
    }: {
      width: '234px',
      height: '303px',
      borderRadius: '5px',
      overflow: 'hidden',
      boxShadow: '2px 2px 12px rgba(0,0,0,0.4)',
      transition: 'transform 0.3s ease, z-index 0.3s ease, box-shadow 0.3s ease',
      transform: isFullSize ? 'scale(0.9)' : 'scale(0.7)',
      zIndex: isFullSize ? 10 : 5,
      margin: '0 auto',
      position: 'relative',
    };
  };

  return (
    <div 
      className="card-carousel" 
      style={{ 
        position: 'relative', 
        width: '100%', 
        maxWidth: '1600px', 
        margin: '0 auto', 
        padding: '0px 0 80px',
      }}
    >
      <Swiper
        ref={swiperRef}
        modules={[Navigation]}
        spaceBetween={0}
        slidesPerView={isMobile?2:7}
        centeredSlides={true}
        loop={true}
        onSlideChange={handleSlideChange}
        onInit={handleSlideChange}
        style={{ 
          width: '100%', 
          padding: '0 40px',
        }}
      >
        {cards.map((card, index) => (
          <SwiperSlide key={index} style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={getCardStyle(index)}>
              <img
                src={card.image}
                alt={card.title}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
              <p
                style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  margin: 0,
                  padding: '12px 8px',
                  fontSize: '14px',
                  color: 'white',
                  textAlign: 'center',
                  background: 'linear-gradient(to top, rgba(44, 44, 44, 0.8), rgba(255,255,255,0))',
                }}
              >
                {card.title}
              </p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* 底部切换按钮 */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '16px',
          position: 'absolute',
          bottom: '0px',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 100,
        }}
      >
        <button
          onClick={handlePrev}
          style={{
            width: '50px',
            height: '50px',
            border: 'none',
            borderRadius: '50%',
            backgroundColor: '#fff',
            boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            padding: 0,
          }}
        >
          <img src={ cardCarouselBtnleft } alt="" />
        </button>
        <button
          onClick={handleNext}
          style={{
            width: '50px',
            height: '50px',
            border: 'none',
            borderRadius: '50%',
            backgroundColor: '#fff',
            boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            padding: 0,
          }}
        >
          <img src={ cardCarouselBtnRight } alt="" />
        </button>
      </div>
    </div>
  );
};

export default CardCarousel;
    